import type { AppState } from '@store/types'

import type { LoaderType } from './types'

export const selectIsLoading =
  (...types: LoaderType[]) =>
  (state: AppState) =>
    types.some((t) => state.loaders.includes(t))
